import * as React from 'react';

interface IProps {
    /** How many of the rows of the list are selected: what can be done with them depends on it */
    selectedCount: number;
    exportStopFile: any;
    importStopFile: any;
    createTruck: any;
    createContainer: any;
    setGroupings: any;
    // Where the menu goes when it would run off the page; the menu is taller with more rows selected
    heightOffset: number;
}

/**
 * What can be done on the routing page.  Exporting and importing the stop file is always there; making a truck or a
 * container of the selected rows needs some, and setting the groupings of the orders of a stop needs only one.
 */
export const RoutingRightClickMenu = (props : IProps) => {
    return (
        <div>
            <p>Direct Route</p>
            <button id="setScheduleBtn" onClick={ props.exportStopFile }>
                <i className="la la-download" />
                Export File
            </button>
            <button id="importStopFileBtn" onClick={ props.importStopFile }>
                <i className="la la-upload" />
                Import Stop File
            </button>

            {
                props.selectedCount > 0
                    ? <React.Fragment>
                        <div className="right-click-divide" />
                        <p>Quick Create</p>
                        <button id="quickCreateTruckBtn" onClick={ props.createTruck }>
                            <i className="la la-truck" />
                            Truck
                        </button>
                        <button id="quickCreateContainerBtn" onClick={ props.createContainer }>
                            <i className="la la-cube" />
                            Container
                        </button>
                    </React.Fragment>
                    : null
            }

            {
                props.selectedCount === 1
                    ? <React.Fragment>
                        <div className="right-click-divide" />
                        <p>Other</p>
                        <button id="setGroupingsBtn" onClick={ props.setGroupings }>
                            <i className="la la-object-ungroup" />
                            Set Groupings
                        </button>
                    </React.Fragment>
                    : null
            }
        </div>
    );
};
